<script>
  import CustomersTable from "../components/customersTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;

  const mountCustomersCount = async () => {
    const module = await import("App/Customers/count");
    const CustomersCount = module.default;

    if (el1) {
      el1.innerHTML = "";
      new CustomersCount({
        target: el1,
      });
    }
  };

  mountCustomersCount();
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <CustomersTable />
    </div>
  </div>
</PageContainer>
